import { ServiceStatusConstant } from '../actions/constants/ServiceStatusConstant';
import { AuthConstant } from '../actions/constants/AuthConstant';

const dedupByTicketKey = (items) => {
	const seen = new Set();
	return (items || []).filter(item => {
		if (seen.has(item.ticketKey)) return false;
		seen.add(item.ticketKey);
		return true;
	});
};

const initialState = {
	isLoading: false,
	countsLoaded: false,
	enabled: false,
	level1: { count: 0, items: [] },
	level2: { count: 0, items: [] },
	level3: { count: 0, items: [] },
	lastUpdated: null,
	error: null,
	wsConnected: false,
};

export const ServiceStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case ServiceStatusConstant.GET_STATUS_SUCCESS: {
			const l1 = action.payload.level1 || { count: 0, items: [] };
			const l2 = action.payload.level2 || { count: 0, items: [] };
			const l3 = action.payload.level3 || { count: 0, items: [] };
			const deduped1 = dedupByTicketKey(l1.items);
			const deduped2 = dedupByTicketKey(l2.items);
			const deduped3 = dedupByTicketKey(l3.items);
			return {
				...state,
				countsLoaded: true,
				enabled: action.payload.enabled,
				level1: { count: deduped1.length, items: deduped1 },
				level2: { count: deduped2.length, items: deduped2 },
				level3: { count: deduped3.length, items: deduped3 },
				lastUpdated: Date.now(),
				error: null,
			};
		}
		case ServiceStatusConstant.GET_STATUS_FAIL:
			return { ...state, countsLoaded: true, error: 'Failed to load service status' };
		case ServiceStatusConstant.GET_COUNTS_SUCCESS:
			return {
				...state,
				countsLoaded: true,
				enabled: action.payload.enabled,
				level1: { ...state.level1, count: action.payload.level1Count || 0 },
				level2: { ...state.level2, count: action.payload.level2Count || 0 },
				level3: { ...state.level3, count: action.payload.level3Count || 0 },
				lastUpdated: Date.now(),
			};
		case ServiceStatusConstant.GET_COUNTS_FAIL:
			return { ...state, countsLoaded: true };
		case ServiceStatusConstant.SET_ENABLED_SUCCESS:
			return {
				...state,
				enabled: action.payload.serviceStatusEnabled,
			};
		case ServiceStatusConstant.LOADING:
			return { ...state, isLoading: true };
		case ServiceStatusConstant.LOADED:
			return { ...state, isLoading: false };
		case ServiceStatusConstant.WS_CONNECTED:
			return { ...state, wsConnected: true };
		case ServiceStatusConstant.WS_DISCONNECTED:
			return { ...state, wsConnected: false };
		case AuthConstant.LOGOUT:
			return initialState;
		default:
			return state;
	}
};
